import { FILTER_TYPES } from 'components/FilterPod';

const filters = () => [
  {
    title: 'نام زیرمجموعه',
    label: 'نام زیرمجموعه',
    keyName: 'name',
    query: 'name',
    id: 1,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {},
  },
  {
    title: 'ایمیل',
    label: 'ایمیل',
    keyName: 'email',
    query: 'email',
    id: 2,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {},
  },
  {
    title: 'شماره موبایل',
    label: 'شماره موبایل',
    keyName: 'cellphoneNumber',
    query: 'cellphoneNumber',
    id: 3,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {},
  },
  {
    title: 'کد اقتصادی',
    label: 'کد اقتصادی',
    keyName: 'economicCode',
    query: 'economicCode',
    id: 4,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {},
  },
  {
    title: 'شناسه ملی',
    label: 'شناسه ملی',
    keyName: 'nationalCode',
    query: 'nationalCode',
    id: 5,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {},
  },
  {
    title: 'شناسه ثبتی',
    label: 'شناسه ثبتی',
    keyName: 'registrationNumber',
    query: 'registrationNumber',
    id: 6,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {},
  },
];

export default filters;
